<div class="card">
  <div class="card-body">
    <div class="card-title" translate>CUSTOMER.MANAGE</div>
    <div class="row">
      <div class="col-md-12">
        <div class="input-group">
          <input
            type="text"
            class="form-control h-100"
            placeholder="{{ 'CUSTOMER.SEARCH' | translate }}"
            [(ngModel)]="customerQuery"
            (keyup.enter)="searchCustomer()"
          />
          <button
            *ngIf="customerQuery !== ''"
            (click)="clearCustomer()"
            class="btn bg-transparent"
            style="margin-left: -40px; z-index: 100; padding: 0"
          >
            <i class="mdi mdi-for-btn mdi-close"></i>
          </button>
          <div class="input-group-append">
            <button
              class="btn btn-outline-secondary"
              type="button"
              (click)="searchCustomer()"
              translate
            >
              SEARCH
            </button>
          </div>
        </div>
      </div>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col" translate>NAME</th>
          <th scope="col" translate>BIRTH</th>
          <th scope="col" translate>CPF</th>
          <th scope="col" translate>GENDER</th>
          <th scope="col" translate>PHONE</th>
          <th scope="col" translate>EMAIL</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let customer of customers; index as i">
          <th scope="row">{{ customer.name }}</th>
          <td>
            {{ customer.age | date: "shortDate" }}
          </td>
          <td>{{ customer.cpforcnpj }}</td>
          <td translate>
            {{ customer.gender == "MALE" ? "MALE" : "FEMALEGENDER" }}
          </td>
          <td>{{ customer.phone }}</td>
          <td>{{ customer.email }}</td>
        </tr>
        <tr>
          <td colspan="6" style="vertical-align: middle; text-align: center">
            <div
              class="btn btn-outline-primary"
              (click)="getAllCustomers()"
              *ngIf="count != customers.length"
              translate
            >
              LOAD-MORE
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
